import React from 'react';
import { sharedStyles } from 'Views/Pages/Pdf/styles';
import { Text, View } from '@react-pdf/renderer';
import { StudyPlanEntity } from 'Models/Entities';
import moment from 'moment';
import { startCase } from 'lodash';

interface FooterProps {
	studyPlan: StudyPlanEntity;
}

const Footer = (props: FooterProps) => {
	const { studyPlan } = props;

	return (
		<>
			<View
				style={[sharedStyles.createdModified, sharedStyles.darkGrey]}
				fixed
			>
				<Text>
					Created by {startCase(studyPlan.ownerName)} on {moment(studyPlan.created).format('DD/MM/YYYY')}
				</Text>
				<Text>
					Modified by {' '}
					{startCase(studyPlan.modifiedByUserName)} on {' '}
					{moment(studyPlan.modified).format('DD/MM/YYYY')}
				</Text>
			</View>
			<Text
				style={[sharedStyles.pageNumber, sharedStyles.darkGrey]}
				render={({ pageNumber, totalPages }) => (
					`Page ${pageNumber} of ${totalPages}`
				)}
				fixed
			/>
		</>
	);
};

export default Footer;
